import styleIcon from 'uiComponents/studio/icons/style.svg'
import { SectionObject } from 'uiComponents/studio/menuItem'
import { t } from 'translations'
import restrictionsIcon from 'uiComponents/studio/icons/target.svg'
import { fontOptions } from '../shared'

export interface FormDefinitionSchema {
    style: SectionObject
    targeting: SectionObject
}

export const getCheckoutFormDefinition = (): FormDefinitionSchema => ({
    style: {
        name: 'style',
        label: t('engageTools.studio.checkout.steps.style'),
        header: t('engageTools.studio.config.headers.designLookAndFeel'),
        icon: styleIcon,
        description: t('engageTools.studio.checkout.descriptions.style'),
        sections: [
            {
                name: t('engageTools.studio.config.sections.globalSettings'),
                fields: [
                    {
                        name: 'logo',
                        type: 'upload',
                        label: t('engageTools.studio.config.fields.uploadLogo'),
                        span: 12,
                        path: 'logo',
                        defaultValue: 'true',
                    },
                    {
                        name: 'brand_color',
                        type: 'picker',
                        label: t('engageTools.studio.config.fields.themeColor'),
                        span: 6,
                        path: 'brandColor',
                        defaultValue: '',
                    },
                ],
            },
            {
                name: t('engageTools.studio.config.sections.buttonSettings'),
                fields: [
                    {
                        name: 'border_radius',
                        type: 'select',
                        availableOptions: [
                            {
                                name: t('engageTools.studio.config.options.square'),
                                value: '0',
                            },
                            {
                                name: t('engageTools.studio.config.options.slightlyRounded'),
                                value: '6',
                            },
                            {
                                name: t('engageTools.studio.config.options.rounded'),
                                value: '10',
                            },
                        ],
                        label: t('engageTools.studio.config.fields.buttonCorners'),
                        span: 8,
                        path: 'borderRadius',
                        defaultValue: '6',
                    },
                    {
                        name: 'button_style',
                        type: 'select',
                        availableOptions: [
                            {
                                name: t('engageTools.studio.config.options.solid'),
                                value: 'solid',
                            },
                            {
                                name: t('engageTools.studio.config.options.gradient'),
                                value: 'gradient',
                            },
                        ],
                        label: t('engageTools.studio.config.fields.buttonStyle'),
                        span: 8,
                        path: '',
                        defaultValue: 'solid',
                    },
                    {
                        name: 'primary_color',
                        type: 'picker',
                        label: t('engageTools.studio.config.fields.buttonColor'),
                        span: 6,
                        path: 'primaryColor',
                        defaultValue: '#000000',
                    },
                    {
                        name: 'primary_color_gradient_stop',
                        type: 'picker',
                        label: t('engageTools.studio.config.fields.buttonColorGradientStop'),
                        span: 6,
                        path: 'primaryColorGradientStop',
                        defaultValue: '#000000',
                    },
                    {
                        name: 'secondary_color',
                        type: 'picker',
                        label: t('engageTools.studio.config.fields.noticeButtonColor'),
                        span: 6,
                        path: 'secondaryColor',
                        defaultValue: '#000000',
                        infotip: t('engageTools.studio.checkout.infotips.noticeButtonColor'),
                    },
                    {
                        name: 'secondary_color_gradient_stop',
                        type: 'picker',
                        label: t('engageTools.studio.config.fields.noticeButtonColorGradientStop'),
                        span: 6,
                        path: 'secondaryColorGradientStop',
                        defaultValue: '#000000',
                    },
                ],
            },
            {
                name: t('engageTools.studio.config.sections.typography'),
                fields: [
                    {
                        name: 'primary_font',
                        type: 'select',
                        availableOptions: [...fontOptions],
                        label: t('engageTools.studio.config.fields.primaryFont'),
                        span: 8,
                        path: 'primaryFont',
                        defaultValue: 'Roboto',
                    },
                    {
                        name: 'custom_font_name_primary',
                        type: 'text',
                        label: t('engageTools.studio.config.fields.customPrimaryFont'),
                        span: 6,
                        path: 'primaryFontCustomName',
                        defaultValue: '',
                    },
                    {
                        name: 'secondary_font',
                        type: 'select',
                        availableOptions: [...fontOptions],
                        label: t('engageTools.studio.config.fields.secondaryFont'),
                        span: 8,
                        path: 'secondaryFont',
                        defaultValue: 'Roboto',
                    },
                    {
                        name: 'custom_font_name_secondary',
                        type: 'text',
                        label: t('engageTools.studio.config.fields.customSecondaryFont'),
                        span: 6,
                        path: 'secondaryFontCustomName',
                        defaultValue: '',
                    },
                    {
                        name: 'custom_font',
                        type: 'textArea',
                        label: t('engageTools.studio.config.fields.customFontImport'),
                        span: 12,
                        path: 'customFont',
                        defaultValue: '',
                        infotip: t('engageTools.studio.checkout.infotips.customFont'),
                    },
                ],
            },
        ],
    },
    targeting: {
        name: 'targeting',
        label: t('engageTools.studio.checkout.steps.targeting'),
        header: t('engageTools.studio.config.headers.setRestrictions'),
        icon: restrictionsIcon,
        feature: 'CRMAudiencesPage',
        description: t('engageTools.studio.checkout.descriptions.targeting'),
        sections: [
            {
                name: 'Audience',
                fields: [],
            },
        ],
    },
})
